import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
    INotificationListingFilterModel,
    INotificationListingModel,
    INotificationReadAPIResponse,
    IUpdateNotificationSettingsModel,
} from '../../../models/notification.model';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService extends BaseApiService {
    protected override endPoint = '/notifications';

    getNotificationListing(filter: INotificationListingFilterModel): Observable<INotificationListingModel> {
        const params = {
            page: filter.page ?? 1,
            size: filter.size ?? 20,
            notificationType: filter.notificationType ?? '',
        };

        return this.http.get<INotificationListingModel>(`${environment.apiServer}/allNotifications`, { params });
    }

    updateNotificationSettings(data: IUpdateNotificationSettingsModel): Observable<void> {
        return this.http.put<void>(`${this.fullPath}`, data);
    }

    readAllNotifications(): Observable<void> {
        return this.http.post<void>(`${this.fullPath}/read/all`, {});
    }

    readNotification(id: number): Observable<INotificationReadAPIResponse> {
        return this.http.post<INotificationReadAPIResponse>(`${this.fullPath}/read/${id}`, {});
    }
}
